import axios from '@/axios'
import helper from './helper'

export default {
  /**
   * Get all segments for a specific episode
   */
  getAllByEpisodeId(episodeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/segments/episode/${episodeId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Get single segment by ID
   */
  get(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/segments/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Create new segment
   * @param {Object} segment - { episodeId, segmentNumber, segmentType, inPoint, outPoint, frameRate, notes }
   */
  create(segment) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/segments', segment)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Update segment
   * @param {Object} segment - { segmentId, segmentNumber, segmentType, inPoint, outPoint, frameRate, notes }
   */
  update(segment) {
    return new Promise((resolve, reject) => {
      axios
        .put('/api/segments', segment)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Delete segment
   */
  remove(segmentId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/segments/${segmentId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Delete multiple segments
   */
  removeMultiple(segmentIds) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/segments/remove-multiple', { segmentIds: segmentIds })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Export segments to CSV for entire series/media
   */
  exportMediaCSV(mediaId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/segments/export/csv/${mediaId}`, {
          responseType: 'blob'
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Export segments to CSV for single episode
   */
  exportEpisodeCSV(episodeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/segments/export/csv/episode/${episodeId}`, {
          responseType: 'blob'
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Helper to download CSV blob
   */
  downloadCSV(blob, filename) {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
}
